import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import common_en from '@betwixt/common/translations/common_en.json';
import common_it from '@betwixt/common/translations/common_it.json';
import global_en from './global_en.json';
import global_it from './global_it.json';
import nav_en from './nav_en.json';
import nav_it from './nav_it.json';
import login_en from './login_en.json';
import login_it from './login_it.json';
import signup_en from './signup_en.json';
import signup_it from './signup_it.json';
import checkout_en from './checkout_en.json';
import checkout_it from './checkout_it.json';

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['it', 'en'],
    fallbackLng: 'it',
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'],
    },
    resources: {
      en: {
        global: global_en,
        common: common_en,
        nav: nav_en,
        signup: signup_en,
        login: login_en,
        checkout: checkout_en,
      },
      it: {
        global: global_it,
        common: common_it,
        nav: nav_it,
        signup: signup_it,
        login: login_it,
        checkout: checkout_it,
      },
    },
    react: { useSuspense: false },
  });
